// import React, { useState } from 'react'
// import { Button, Checkbox, CustomSelect, Divider, FormFieldSet, InfoTimeCard, NewTable, PageHeader, PageTitle, Tag, useFormHandler } from '../../../../../components'
// import { paymentrowData } from '../../../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../../../utils';
// import BankInformationModal from './Models/bankinformationModal';

// const CreatePayment = ({ onBack }) => {
//   const [model, setmodel] = useState(false);

//   const tablerowData = paymentrowData;
//   const { formData, errors, handleChange, validateAllFields } = useFormHandler({
//     Vendor: "",

//   });

//   const AllbillsColumns = [

//     { key: "Description", label: "Description" },
//     { key: "DueDate", label: "Due Date" },
//     { key: "OriginalAmount", label: " Original Amount" },
//     { key: "PaymentReceived", label: " Payment Received" },
//     { key: "OpenBalance", label: "Open Balance" },
//     { key: "EnterPaymentAmount", label: "Enter Payment Amount" },
//     { key: "PaymentDiscount", label: " Payment Discount" },
//     {
//       key: "action",
//       label: "",
//       render: (row) => (
//         <CustomSelect
//           type="select"
//           title=""
//           placeholder="Discount"
//           value={formData.Discount}
//           onChange={(value) => handleChange("Discount", value)}
//           error={errors.Discount}
//           size='xs'
//         />
//       ),
//       sortable: false,
//     },
//   ];
//   const mappedRows = mapTableRows(tablerowData, AllbillsColumns);

//   const handleViewBankDetails = () => {
//     setmodel(!model)
//   }

//   return (
//     <div>
//       <div>
//         <PageHeader
//           Section={
//             <div className="flex gap-3">
//               <PageTitle title={"Create Vendor Payment"} tag="h5" size={"sm"} />
//               <Tag
//                 title="Tektree"
//                 variant="outlined"
//                 className=" !text-neutrals !py-1.5"
//               />
//             </div>
//           }
//           RightSection={
//             <div className="flex gap-3">
//               <Button
//                 size="sm"
//                 title={"Back"}
//                 icon={"arrow_left_alt"}
//                 onClick={onBack}
//               />

//             </div>
//           }
//         />
//       </div>
//       <div className="grid grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
//         <FormFieldSet
//           type="select"
//           title="Vendor"
//           placeholder=" select Vendor"
//           value={formData.Vendor}
//           onChange={(value) => handleChange("Vendor", value)}
//           error={errors.Vendor}
//         />
//         <div className='mt-5'>
//           <Button
//             title={"View Bank Details"}
//             onClick={handleViewBankDetails}
//           />
//         </div>
//         <div></div>
//         <div className='mr-10 mt-5'>
//           <InfoTimeCard
//             title="Paid Amount"
//             color="primary"
//             value={"147833.72"}
//             suffix={"USD"}
//             type2
//           />
//         </div>
//         <FormFieldSet
//           type="select"
//           title="Payment Date"
//           placeholder=" select Payment Date"
//           value={formData.PaymentDate}
//           onChange={(value) => handleChange("PaymentDate", value)}
//           error={errors.PaymentDate}
//         />
//         <FormFieldSet
//           type="select"
//           title="Payment Type"
//           placeholder=" select Payment Type"
//           value={formData.PaymentType}
//           onChange={(value) => handleChange("PaymentType", value)}
//           error={errors.PaymentType}
//         />
//         <FormFieldSet
//           type="select"
//           title="Account Type"
//           placeholder=" select AccountType"
//           value={formData.AccountType}
//           onChange={(value) => handleChange("AccountType", value)}
//           error={errors.AccountType}
//         />
//         <div></div>
//         <FormFieldSet
//           type="select"
//           title="Reference Number"
//           placeholder=" select Reference Number"
//           value={formData.ReferenceNumber}
//           onChange={(value) => handleChange("ReferenceNumber", value)}
//           error={errors.ReferenceNumber}
//         />
//         <FormFieldSet
//           type="textArea"
//           title="Notes"
//           placeholder=" select Notes"
//           value={formData.Notes}
//           onChange={(value) => handleChange("Notes", value)}
//           error={errors.Notes}
//         />
//         <div></div>
//         <FormFieldSet
//           type="select"
//           title=" Paid Amount"
//           placeholder=" select  Paid Amount"
//           value={formData.PaidAmount}
//           onChange={(value) => handleChange("PaidAmount", value)}
//           error={errors.PaidAmount}
//         />
//       </div>
//       <div className="flex justify-end">
//         <Button
//           size="md"
//           title={"Clear Payment"}
//           onClick={onBack}
//         />
//       </div>
//       <div>
//         <NewTable
//         showCheckbox
//           columns={AllbillsColumns}
//           rows={mappedRows}
//           toolbarRight={[
//             { filterButton: false },
//             { DropdownMenu: false },
//           ]}
//         />
//       </div>
//       <div className="flex items-center justify-between mt-5">
//         <p> Invoice Details</p>
//         <Button
//           size="sm"
//           title={"Add"}
//           onClick={""}
//           color='black'
//           icon={"add"}
//         />
//       </div>
//       <div>
//         <BankInformationModal
//           open={model}
//           onClose={() => setmodel(!model)}
//         />
//       </div>
//      <Divider/>
//       <div className="flex gap-3 justify-end my-6">
//         <Button title="Cancel" variant="outlined" onClick={""} />
//         <Button title="Save" onClick={""} />
//       </div>
//     </div>
//   )
// }
// export default CreatePayment

import React, { useState } from "react";
import {
  Button,
  Checkbox,
  CustomSelect,
  Divider,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCard,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  TableAdv,
  Tag,
  useFormHandler,
} from "../../../../../components";
import { paymentrowData } from "../../../../../assets/data/candidatesData";
import { mapTableRows } from "../../../../../utils";
import BankInformationModal from "./Models/bankinformationModal";
import {
  AccountpayableAccountType,
  Accountpayablepaytype,
  vendortypes,
} from "../../../../../assets/data/projectData";
import { getVendorId } from "../../../../../utils/getClientId";

const CreatePayment = ({ onBack }) => {
  const [model, setmodel] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  //vinay fake data
  // const tablerowData = paymentrowData;
  const tablerowData = paymentrowData;
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      Vendor: "",
      attachment: [],
    },
    {
      attachment: { type: "file" },
    },
  );
  console.log(
    "formData",
    Object.keys(formData)
      .sort()
      .reduce((obj, key) => {
        obj[key] = formData[key];
        return obj;
      }, {}),
  );

  const AllbillsColumns = [
    { key: "Description", label: "Description" },
    { key: "DueDate", label: "Due Date" },
    { key: "OriginalAmount", label: " Original Amount" },
    { key: "PaymentReceived", label: " Payment Received" },
    { key: "OpenBalance", label: "Open Balance" },
    { key: "EnterPaymentAmount", label: "Enter Payment Amount" },
    { key: "PaymentDiscount", label: " Payment Discount" },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  // Add id field to each row for TableAdv
  const dataWithIds = tablerowData.map((item, index) => ({
    ...item,
    id: item.id || index, // Ensure each row has an id
  }));

  const mappedRows = mapTableRows(dataWithIds, AllbillsColumns);

  const handleViewBankDetails = () => {
    setmodel(!model);
  };

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);
  };

  const handleSave = (status) => {
    const isValid = validateAllFields();
    if (isValid) {
      let payload;
      //       {
      //     "AccountType": "Citizen Bank Checking (QB)",
      //     "Notes": "434343",
      //     "PaidAmount": "343",
      //     "PaymentDate": "2025-06-08T18:30:00.000Z",
      //     "PaymentType": "ACH Payment",
      //     "ReferenceNumber": "454553",
      //     "Vendor": {
      //         "label": "kunze and sons | VEN-999",
      //         "value": 999
      //     },
      //     "attachment": [
      //         {},
      //         {}
      //     ]
      // }
      if (false) {
        showToast("Edit In Progress");
      } else {
        payload = {
          entityId: formData.Vendor.value,
          entityType: "Vendor",
          paymentDate: formData.PaymentDate || undefined,
          payType: formData.PaymentType || undefined,
          refNum: formData.PaymentType || undefined,
        };
      }
    } else {
      showToast("Please fix the errors before submitting.", "error", 2000);
    }
  };
  return (
    <div className="px-2 py-2 w-full overflow-auto">
      <div>
        <PageHeader
          Section={
            <div className="flex gap-3">
              <PageTitle title={"Create Vendor Payment"} tag="h5" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={onBack}
              />
            </div>
          }
        />
      </div>
      <div className="grid grid-cols-3 xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="allVendorsList"
          title=" Vendor"
          placeholder="select Vendor"
          value={
            formData?.Vendor?.label
              ? formData.Vendor.label
              : formData?.Vendor?.uiid
                ? `${formData?.Vendor?.businessName || ""} | ${getVendorId(
                    formData?.Vendor?.uiid || "",
                  )}`
                : ""
          }
          showSearch
          onChange={(value) => {
            console.log("vendor list changeid", value);
            handleChange("Vendor", value);
          }}
          error={errors.Vendor}
        />
        <div className="mt-5">
          <Button title={"View Bank Details"} onClick={handleViewBankDetails} />
        </div>
        <div className="hidden xl:block" />
        <div className="mr-10 mt-5">
          <InfoCardNewAdv
            layout="option12"
            title="Paid Amount"
            value={"147833.72"}
            valueConfig={{ decimals: 2, className: "text-[16px]!" }}
            titleConfig={{ className: "text-[12px]!" }}
            suffix="USD"
            suffixConfig={{ className: "font-normal! mt-1! text-[12px]!" }}
          />
        </div>
        {/* <div className="mr-10 mt-5">
          <InfoTimeCard
            title="Paid Amount"
            color="primary"
            value={"147833.72"}
            suffix={"USD"}
            type2
          />
        </div> */}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="datepicker"
          title="Payment Date"
          placeholder=" select Payment Date"
          value={formData.PaymentDate}
          onChange={(value) => handleChange("PaymentDate", value)}
          error={errors.PaymentDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="select"
          title="Payment Type"
          placeholder=" select Payment Type"
          value={formData.PaymentType}
          onChange={(value) => handleChange("PaymentType", value)}
          error={errors.PaymentType}
          options={Accountpayablepaytype}
        />
        <FormFieldSet
          type="select"
          title="Account Type"
          placeholder=" select AccountType"
          value={formData.AccountType}
          onChange={(value) => handleChange("AccountType", value)}
          error={errors.AccountType}
          options={AccountpayableAccountType}
        />
        <FormFieldSet
          type="text"
          title="Reference Number"
          placeholder=" select Reference Number"
          value={formData.ReferenceNumber}
          onChange={(value) => handleChange("ReferenceNumber", value)}
          error={errors.ReferenceNumber}
        />
        <FormFieldSet
          type="textArea"
          title="Notes"
          placeholder=" select Notes"
          value={formData.Notes}
          onChange={(value) => handleChange("Notes", value)}
          error={errors.Notes}
        />
        <FormFieldSet
          type="text"
          title=" Paid Amount"
          placeholder=" select  Paid Amount"
          value={formData.PaidAmount}
          onChange={(value) => handleChange("PaidAmount", value)}
          error={errors.PaidAmount}
        />
      </div>
      <div className="flex justify-end">
        <Button size="md" title={"Clear Payment"} onClick={onBack} />
      </div>
      <div className="flex-1 flex overflow-hidden mt-4">
        <TableAdv
          tableId={`accountspayable_payments_addpayment`}
          showCheckbox
          columns={AllbillsColumns}
          rows={mappedRows}
          onSelectionChange={handleSelectionChange}
          defaultSelectedRows={selectedRows}
          toolbarRight={{
            filter: false,
            search: true,
          }}
        />
      </div>
      <div className="flex justify-end mt-4">
        <div className=" text-black  flex gap-4 min-w-[400px] ">
          <div className="flex-1  justify-center text-center  border-white px-4 py-3">
            Amount to Apply
          </div>
          <div className="w-px bg-white mx-2" />
          <div className="flex-1 px-4 py-3">0.00 USD</div>
        </div>
      </div>
      <div className="flex justify-end">
        <div className=" text-black  flex gap-4 min-w-[400px] ">
          <div className="flex-1  justify-center text-center  border-white px-4 py-3">
            Amount to Credit
          </div>
          <div className="w-px bg-white mx-2" />
          <div className="flex-1 px-4 py-3">0.00 USD</div>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4 mb-2">
        <FormFieldSet
          type="file"
          title={"Upload Attachment"}
          placeholder="Choose File"
          multiple
          value={formData.attachment}
          onChange={(value) => handleChange("attachment", value)}
          error={errors.attachment}
        />
      </div>
      <div className="flex items-center justify-between mt-5">
        <p>ACTIVITIES</p>
        <BankInformationModal open={model} onClose={() => setmodel(!model)} />
      </div>
      <Divider />
      <div className="flex gap-3 justify-end my-6">
        <Button title="Cancel" variant="outlined" onClick={onBack} />
        <Button
          title="Save"
          onClick={() => {
            console.log("formData", formData);
          }}
        />
      </div>
    </div>
  );
};
export default CreatePayment;
